import { ExclamationCircleOutlined } from '@ant-design/icons';
import { TabsProducts } from '@features/products/components/productExhibition/tabs/TabsProducts';
import useProductExhibition from '@features/products/hooks/useProductExhibition';
import { ModalAlert } from '@molecules';
import { PageHeader } from '@organisms';
import { Flex } from 'antd';

import { SkeletonProductExhibition } from '../skeletonProductExhibition';

export const ProductExhibition: React.FC = () => {
  const {
    hasResourcesLoading,
    columns,
    columnVisibilityState,
    createButtonComponent,
    optionsTabProducts,
    DrawerOfferBulk,
    handleCancelSwitchActiveProduct,
    handleSwitchActiveProduct,
    switchActiveProduct,
    isLoadingSwitchStatus,
  } = useProductExhibition();

  if (hasResourcesLoading) {
    return (
      <SkeletonProductExhibition
        optionsTabProducts={optionsTabProducts}
        columnsTable={columnVisibilityState?.visibleColumns || columns}
      />
    );
  }

  return (
    <>
      <PageHeader
        title={'Produtos'}
        subTitle={'Gerencie, edite e crie novos produtos e ofertas.'}
        extra={createButtonComponent}
      />

      <TabsProducts optionsTabProducts={optionsTabProducts} />
      <DrawerOfferBulk />
      {switchActiveProduct && (
        <ModalAlert
          showModal={!!switchActiveProduct}
          titleLabel={`${!switchActiveProduct.active ? 'Ativar' : 'Inativar'} produto`}
          messageLabel={
            <Flex style={{ marginLeft: 24 }} vertical>
              {`Você está prestes a ${!switchActiveProduct.active ? 'ativar' : 'inativar'} este produto, tem certeza que deseja continuar?`}
            </Flex>
          }
          denyButtonLabel='Cancelar'
          denyButtonAction={handleCancelSwitchActiveProduct}
          confirmButtonLabel={`${!switchActiveProduct.active ? 'Ativar' : 'Inativar'} produto`}
          confirmButtonAction={handleSwitchActiveProduct}
          icon={
            <ExclamationCircleOutlined style={{ color: '#D89614' }} size={24} />
          }
          isDangerConfirmButton
          hideCloseButtonHeader
          isLoading={isLoadingSwitchStatus}
          isCentered
        />
      )}
    </>
  );
};
